import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from 'react-select';
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import TableContainer from "../../utils/TableContainer";
import Timeformat from "../../utils/Timeformat";
import StaticFunctions from "../../utils/StaticFunctions";
import CheckBoxField from "../../utils/CheckBoxField";

class CompanyEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        company: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            inputError: [],
            currentCompany: null,
            currentCompanyUsers: [],
            currentParentCompany: null,
            companyList: [],
            parentCompanyList: [],
            mainUserList: [],
            inputParams: {
                id: this.props.company.id,
                name: this.props.company.name,
                parentId: this.props.company.id_parent,
                rootId: this.props.company.id_root,
                mainUserId: this.props.company.id_main_user,
                timezone: this.props.company.timezone,
                info: this.props.company.info,
                vatNumber: this.props.company.vatNumber,
                locationCount: this.props.company.location_count,
                machineCount: this.props.company.machine_count,
                userCount: this.props.company.user_count,
                operatorCount: this.props.company.operator_count,
                //patternCount: this.props.company.pattern_count,
                dateCreated: this.props.company.date_created,
                dateLicenced: this.props.company.date_licenced,
                dateDeleted: this.props.company.date_deleted,
                lastUpdate: this.props.company.last_update,
                apiEnabled: !!(this.props.company.api_enabled && (parseInt(this.props.company.api_enabled) === 1 || this.props.company.api_enabled === true)),
                aiConnectorEnabled: !!(this.props.company.ai_connector_enabled && (parseInt(this.props.company.ai_connector_enabled) === 1 || this.props.company.ai_connector_enabled === true)),
            }
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanies = this.requestCompanies.bind(this);
        this.requestCompanyUsers = this.requestCompanyUsers.bind(this);
        this.requestCompanyLicence = this.requestCompanyLicence.bind(this);
        this.requestParentCompanies = this.requestParentCompanies.bind(this);
        this.requestCancelCompanyLicence = this.requestCancelCompanyLicence.bind(this);
        this.getInput = this.getInput.bind(this);
        this.getCompanyById = this.getCompanyById.bind(this);
        this.selectCompany = this.selectCompany.bind(this);
        this.selectParentCompany = this.selectParentCompany.bind(this);
        this.selectMainUser = this.selectMainUser.bind(this);
        this.selectTimezone = this.selectTimezone.bind(this);
        this.cancelCompanyLicence = this.cancelCompanyLicence.bind(this);

    }

    componentWillMount() {

        this.requestCompanies();
        this.requestCompanyUsers();
        this.requestCompanyLicence();
        this.requestParentCompanies();

    }

    requestCompanies() {

        const params = {
            action: 'getCompanies',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.company.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companyList: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCompanyUsers() {

        const params = {
            action: 'getCompanyUsers',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.company.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyUsers: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCompanyLicence() {

        const params = {
            action: 'getCompanyLicence',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.company.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyLicence: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestParentCompanies() {

        const params = {
            action: 'getParentCompanies',
            currentCompanyId: this.props.baseData.companies.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    parentCompanyList: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCancelCompanyLicence(licenceId) {

        if (licenceId) {
            const params = {
                action: 'cancelCompanyLicence',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                licenceId: licenceId,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    if (res.success) this.requestCompanyLicence();

                    alert(this.translate(res.msgKey));
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    enterSaveEditCompany(event) {

        if (event.keyCode === 13) {
            this.saveEditCompany();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditCompany() {

        const inputError = this.state.inputError;
        const inputParams = this.state.inputParams;

        console.debug(inputError);
        if (inputError.length === 0 && inputParams && inputParams.id && inputParams.name) {
            const params = {
                action: 'editCompany',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                id: inputParams.id,
                parentId: inputParams.parentId,
                rootId: inputParams.rootId,
                name: inputParams.name,
                info: inputParams.info,
                mainUserId: inputParams.mainUserId,
                timezone: inputParams.timezone,
                vatNumber: inputParams.vatNumber,
                apiEnabled: inputParams.apiEnabled,
                aiConnectorEnabled: inputParams.aiConnectorEnabled,
                dateDeleted: null
            };

            const callback = function (res) {
                this.resetInputError();

                if (res.success) {
                    alert(this.translate(res.msgKey));

                    if (this.props.baseData.requestCompanies) {
                        this.props.baseData.requestCompanies();
                    }

                    const currentCompany = this.props.baseData.companies.getCurrentCompany();
                    if (currentCompany && parseInt(currentCompany.id) === parseInt(inputParams.id)) {
                        if (this.props.baseData.requestUserData) {
                            this.props.baseData.requestUserData();
                        }
                    }

                    this.props.changeView();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!inputParams.name) this.addInputError('name');

            alert(this.translate('errorOccured'));
        }

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    addInputError(field) {

        const errorFields = this.state.inputError;

        errorFields.push(field);

        this.setState({
            inputError: errorFields,
        });

    }

    removeInputError(field) {

        const errorFields = this.state.inputError.filter(e => e !== field);

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = value;

        if (isValid) {
            this.removeInputError(name);
        } else {
            this.addInputError(name);
        }

        this.setState({inputParams});

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    getSelectParentCompanies() {

        if (!this.props.company || !this.state.parentCompanyList) return [];

        const currentCompany = this.props.company;
        const companyList = this.state.parentCompanyList;
        const parentList = [];

        for (let ix in companyList) {
            let company = companyList[ix];

            if (company.id !== currentCompany.id) {
                parentList.push({
                    label: company['name'] + ' (' + company['id'] + ')',
                    value: company['id']
                });
            }
        }

        return parentList;

    }

    getMainUserSelectionList() {

        if (!this.props.company || !this.state.currentCompanyUsers) return [];

        const selectionList = this.state.currentCompanyUsers;
        const rows = [];

        for (let ix in selectionList) {
            let item = selectionList[ix];

            rows.push({
                label: item.email,
                value: item.id
            });
        }

        return StaticFunctions.getSortedData(rows, 'label', 'string');

    }

    getTimezones() {

        return this.props.timezones.map((tz) => {
            let gmt = StaticFunctions.getGmtFromTimezoneString(tz);
            let label = tz + ((gmt) ? ' ' + gmt : '');

            return {
                label: label,
                value: tz
            }
        });

    }

    getCompanyById(companyId) {

        const companies = this.state.companyList;

        let company = null;

        if (companyId && companies) {
            companies.forEach(
                (comp) => {
                    if (comp.id === companyId) {
                        company = comp;
                    }
                }
            );
        }

        return company;

    }

    resetSelectedCompany() {

        this.setState({
            inputError: [],
            currentCompany: null,
            currentCompanyUsers: [],
            currentParentCompany: null,
        });

    }

    selectCompany(event) {

        if (!event || !event.value) return;

        const currentCompany = this.getCompanyById(event.value);

        if (currentCompany) {
            let currentParentCompany = this.getCompanyById(currentCompany.id_parent);
            let currentCompanyUsers = this.requestCompanyUsers(currentCompany.id);
            let currentCompanyLicence = this.requestCompanyLicence(currentCompany.id);

            this.setState({
                currentCompany,
                currentCompanyUsers,
                currentCompanyLicence,
                currentParentCompany,
            });
        }

    }

    selectParentCompany(event) {

        if (!event || !event.value) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams.parentId = event.value;

            this.setState({
                inputParams,
                currentParentCompany: this.getCompanyById(event.value)
            });
        }

    }

    selectMainUser(event) {

        if (!event || !event.value) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams.mainUserId = event.value;

            this.setState({
                inputParams,
                mainUserId: event.value
            });
        }

    }

    selectTimezone(event) {

        if (!event || !event.value) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams.timezone = event.value;

            this.setState({
                inputParams
            });
        }

    }

    cancelCompanyLicence(licence) {

        if (licence && licence.date_canceled === null) {
            const timezone = this.props.baseData.companies.currentCompany.timezone;

            let confirmedText = this.translate('areYouSureYouWantToCancelTheLicence');

            confirmedText = confirmedText.replace('__date_licence_start__', Timeformat.fromUnix(licence.date_licenced_from).getFormatedDate(this.timeFormats.datetime, timezone));
            confirmedText = confirmedText.replace('__date_licence_end__', Timeformat.fromUnix(licence.date_licenced_till).getFormatedDate(this.timeFormats.datetime, timezone));

            const confirmed = window.confirm(confirmedText);

            if (confirmed) this.requestCancelCompanyLicence(licence.id);
        }

    }

    getCompanyUserColumns() {

        return [
            {
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            },
            {
                key: 'email',
                nameKey: 'email',
                sortType: 'string',
            },
            {
                key: 'firstName',
                nameKey: 'firstName',
                sortType: 'string',
            },
            {
                key: 'lastName',
                nameKey: 'lastName',
                sortType: 'string',
            },
            {
                key: 'lastSeen',
                nameKey: 'lastSeen',
                sortType: 'datetime',
            },
            {
                key: 'dateDeleted',
                nameKey: 'deletedOn',
                sortType: 'datetime',
            },
        ];

    }

    getCompanyUserRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const data = (this.state.currentCompanyUsers) ? this.state.currentCompanyUsers : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let lastSeen = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(format, timezone) : '-';
            let dateDeleted = (rowTemp.date_deleted) ? Timeformat.fromUnix(rowTemp.date_deleted).getFormatedDate(format, timezone) : '-';

            rows.push({
                id: rowTemp.id,
                email: rowTemp.email,
                firstName: rowTemp.first_name,
                lastName: rowTemp.last_name,
                lastSeen: lastSeen,
                dateDeleted: dateDeleted,
            });
        }

        return rows;

    }

    getCompanyLicenceColumns() {

        return [
            {
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            },
            {
                key: 'user',
                nameKey: 'user',
                sortType: 'string',
            },
            {
                key: 'productName',
                nameKey: 'productName',
                sortType: 'string',
            },
            {
                key: 'dateCreated',
                nameKey: 'dateCreated',
                sortType: 'datetime',
            },
            {
                key: 'dateLicencedFrom',
                nameKey: 'dateLicencedFrom',
                sortType: 'datetime',
            },
            {
                key: 'dateLicencedTill',
                nameKey: 'dateLicencedTill',
                sortType: 'datetime',
            },
            {
                key: 'dateCanceled',
                nameKey: 'dateCanceled',
                sortType: 'datetime',
            },
            {
                key: 'canceledBy',
                nameKey: 'canceledBy',
                sortType: 'string',
            },
            {
                key: 'options',
                nameKey: 'options',
            }
        ];

    }

    getCompanyLicenceRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const data = (this.state.currentCompanyLicence) ? this.state.currentCompanyLicence : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let dateCreated = (rowTemp.date_created) ? Timeformat.fromUnix(rowTemp.date_created).getFormatedDate(format, timezone) : '';
            let dateLicencedFrom = (rowTemp.date_licenced_from) ? Timeformat.fromUnix(rowTemp.date_licenced_from).getFormatedDate(format, timezone) : '';
            let dateLicencedTill = (rowTemp.date_licenced_till) ? Timeformat.fromUnix(rowTemp.date_licenced_till).getFormatedDate(format, timezone) : '';
            let dateCanceled = (rowTemp.date_canceled) ? Timeformat.fromUnix(rowTemp.date_canceled).getFormatedDate(format, timezone) : '';

            let userName = ((rowTemp.user_first_name !== null) ? rowTemp.user_first_name : '') + ((rowTemp.user_last_name) ? ' ' + rowTemp.user_last_name : '');
            let canceledByName = ((rowTemp.canceled_by_first_name !== null) ? rowTemp.canceled_by_first_name : '') + ((rowTemp.canceled_by_last_name) ? ' ' + rowTemp.canceled_by_last_name : '');

            rows.push({
                id: rowTemp.id,
                user: userName.trim(),
                productName: this.translate(rowTemp.product_name_key),
                dateCreated: dateCreated,
                dateLicencedFrom: dateLicencedFrom,
                dateLicencedTill: dateLicencedTill,
                dateCanceled: dateCanceled,
                canceledBy: canceledByName.trim(),
                options: <div className="tableOptions">
                    <a className="optionCancel" onClick={() => this.cancelCompanyLicence(rowTemp)} title={this.translate('cancelLicence')}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const parentCompanies = this.getSelectParentCompanies();
        const mainUserSelectionList = this.getMainUserSelectionList();
        const inputParams = this.state.inputParams;
        const dateCreated = (inputParams.dateCreated) ? Timeformat.fromUnix(inputParams.dateCreated).getFormatedDate(format, timezone) : '-';
        const dateLicenced = (inputParams.dateLicenced) ? Timeformat.fromUnix(inputParams.dateLicenced).getFormatedDate(format, timezone) : '-';
        const dateDeleted = (inputParams.dateDeleted) ? Timeformat.fromUnix(inputParams.dateDeleted).getFormatedDate(format, timezone) : '-';
        const lastUpdate = (inputParams.lastUpdate) ? Timeformat.fromUnix(inputParams.lastUpdate).getFormatedDate(format, timezone) : '-';

        const userColumns = this.getCompanyUserColumns();
        const userRows = this.getCompanyUserRows();
        const licenceColumns = this.getCompanyLicenceColumns();
        const licenceRows = this.getCompanyLicenceRows();

        return (
            <div className="formSettings clearfix">
                <div className="ma-bo-20 clearfix">
                    <div className="col-lg-4">
                        <div>
                            <nav>
                                <h1>{this.translate('companySettings')}</h1>
                            </nav>
                        </div>

                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('id')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="id"
                                                disabled={true}
                                                value={inputParams.id}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('name')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="name"
                                                className={this.checkInputError('name')}
                                                value={inputParams.name}
                                                isRequired={true}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('parentCompany')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="id_parent"
                                                className="chosen-container chosen-container-single"
                                                style={{width: '260px'}}
                                                options={parentCompanies}
                                                onChange={this.selectParentCompany}
                                                value={parentCompanies.find(o => String(o.value) === String(inputParams.parentId)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={false}
                                                noResultsText={this.translate('noResultsFound')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('myzskLoginId')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="mainUserId"
                                                className="chosen-container chosen-container-single"
                                                style={{width: '260px'}}
                                                options={mainUserSelectionList}
                                                onChange={this.selectMainUser}
                                                value={mainUserSelectionList.find(o => String(o.value) === String(inputParams.mainUserId)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={false}
                                                noResultsText={this.translate('noResultsFound')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('timezone')}</td>

                                        <td className="text-left">
                                            {(() => {
                                                const timezones = this.getTimezones();
                                                const selectedTimezone = timezones.find(o => String(o.value) === String(inputParams.timezone)) || null;
                                                return (
                                                    <Select
                                                        name="timezone"
                                                        className="chosen-container chosen-container-single"
                                                        style={{width: '260px'}}
                                                        options={timezones}
                                                        onChange={this.selectTimezone}
                                                        value={selectedTimezone}
                                                        placeholder={this.translate('select') + '...'}
                                                        clearable={false}
                                                        noResultsText={this.translate('noResultsFound')}
                                                    />
                                                );
                                            })()}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('info')}</td>

                                        <td className="text-left">
                                            <TextAreaField
                                                name="info"
                                                value={inputParams.info}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('vatNumber')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="vatNumber"
                                                className={this.checkInputError('vatNumber')}
                                                value={inputParams.vatNumber}
                                                isRequired={false}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('customerApi')}</td>

                                        <td className="text-left">
                                            <CheckBoxField
                                                name="apiEnabled"
                                                label={""}
                                                isChecked={inputParams.apiEnabled}
                                                onChange={(name, value) => this.getInput(null, name, value, true)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('aiConnector')}</td>

                                        <td className="text-left">
                                            <CheckBoxField
                                                name="aiConnectorEnabled"
                                                label={""}
                                                isChecked={inputParams.aiConnectorEnabled}
                                                onChange={(name, value) => this.getInput(null, name, value, true)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('locations')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="locationCounter"
                                                disabled={true}
                                                value={inputParams.locationCount}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('machines')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="machineCounter"
                                                disabled={true}
                                                value={inputParams.machineCount}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('user')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="userCounter"
                                                disabled={true}
                                                value={inputParams.userCount}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('operator')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="operatorCounter"
                                                disabled={true}
                                                value={inputParams.operatorCount}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateCreated')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_created"
                                                disabled={true}
                                                value={dateCreated}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateLicenced')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_licenced"
                                                disabled={true}
                                                value={dateLicenced}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateDeleted')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_deleted"
                                                disabled={true}
                                                value={dateDeleted}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('lastChange')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="last_update"
                                                disabled={true}
                                                value={lastUpdate}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.changeView()}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.saveEditCompany()} onKeyDown={(event) => this.enterSaveEditCompany(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div>
                            <nav>
                                <h1>{this.translate('companyUsers')}</h1>
                            </nav>
                        </div>

                        <TableContainer
                            baseData={this.props.baseData}
                            columns={userColumns}
                            rows={userRows}
                            fillGaps="-"
                        />
                    </div>

                    <div className="ma-bo-20 clearfix">
                        <div>
                            <nav>
                                <h1>{this.translate('companyLicences')}</h1>
                            </nav>
                        </div>

                        <TableContainer
                            baseData={this.props.baseData}
                            columns={licenceColumns}
                            rows={licenceRows}
                            fillGaps="-"
                        />
                    </div>
                </div>
            </div>
        );

    }

}

export default CompanyEditContainer;
